import { render, staticRenderFns } from "./dataPermissionsDetail.vue?vue&type=template&id=21f9688b"
import script from "./dataPermissionsDetail.vue?vue&type=script&lang=js"
export * from "./dataPermissionsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports